// İSG uzmanı portalı — İş İzni (Permits) erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir (`[ModuleAction("permits", …)]`); bu kapı yalnız UX'tir:
// erişim sondasının (usePermitsAccess) sonucuna göre İş İzni alt-ağacını (Outlet: liste +
// detay), 403 sayfasını veya "kullanılamıyor" durumunu gösterir. Taşeron/Ziyaretçi
// kapılarıyla aynı desen; iş modülü olarak AYRIDIR.

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { ClipboardCheck, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { usePermitsAccess } from '../../lib/permitsAccess';

export function PermitsGate() {
  const { t } = useTranslation();
  const access = usePermitsAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('permits.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <ClipboardCheck className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('permits.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('permits.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('permits.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('permits.unavailable.title')}</h1>
              <p className="text-sm text-muted">{t('permits.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('permits.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
